import { Conflict } from "./Conflict";

export const defaultMessage: Conflict = {
  message: "This looks like fun!",
  level: "SUCCESS",
};
export const potentialClashMessage: Conflict = {
  message: "There are clashes which may effect your game:",
  level: "NEUTRAL",
};
